import { IUsageGroupState } from "../../redux/types/IUsageGroupState";
import { IValidationMessage } from "../../repertoire/types/IValidationMessage";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { adjustProgramDates, isInvalidDateTimeRange, timeToMinutes } from "../../util/tools";

export class MembersPortalLivePerformanceValidator {

    public static validateLivePerformance(usage: IUsageGroupState, livePerformanceMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem): IValidationMessage[] {
        let livePerformanceIsValid: IValidationMessage[];
        livePerformanceIsValid = [];
        let fields = livePerformanceMaintenanceGeneralDataViewData?.fields;
        if (Boolean(usage.fullPerformer) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformancePerformerNotSet")?.data :  "Performer field cannot be empty"})
        }
        if (Boolean(usage.location) === undefined) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenueNotSet")?.data : "Please enter valid Venue" })
        }
        if (Boolean(usage.venueDetails.firstName) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceFirstNameNotSet")?.data : "Firstname field cannot be empty" })
        }
        if (Boolean(usage.venueDetails.lastName) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceLastNameNotSet")?.data : "Lastname field cannot be empty" })
        }
        if (Boolean(usage.venueDetails.phoneNumber) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceContactNumberNotSet")?.data : "Contact number field cannot be empty" }) 
        }
        if (Boolean(usage.venueDetails.venueType) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenueTypeNotSet")?.data : "Venue type field cannot be empty" })
        }
        if (Boolean((usage.livePerformanceSetList)) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceSetlistAvailable")?.data : "Please select Setlist available" })
        }
        if (!usage.location && !usage.venueDetails.venueCode && !usage.venueDetails.venueName) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenuefieldNotSet")?.data : "Venue field cannot be empty" })
        }
        if (usage.files.length===0) {
              livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformancePerformanceProofNotSet")?.data : "Proof of Performance field cannot be empty" })
        }
        usage.usages.map((element, index) => {
            const programEndDate = element.programEndDate?.value;
            const hasDateOnlyEnd = index === 0 && /^\d{4}-\d{2}-\d{2}$/.test(programEndDate);
            const hasPerformanceEndDate = index > 0 || hasDateOnlyEnd || programEndDate?.includes("T");
            const hasProgramEndTime = index > 0 ? !!programEndDate : !!programEndDate && !hasDateOnlyEnd;
            if (!element.usageDate?.value) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidPerformanceDate")?.data : "Please enter a valid Performance Date From" })
            }
            if (!hasPerformanceEndDate) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidPerformanceEndDate")?.data : "Please enter a valid Performance Date To" })
            }
            if (!element.programStartDate?.value) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidStartDate")?.data : "Please enter valid Start time" })
            }
            if (!hasProgramEndTime) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidEndDate")?.data : "Please enter valid End time" })
            }
            if (hasPerformanceEndDate && element.programStartDate?.value && hasProgramEndTime && isInvalidDateTimeRange(element.programStartDate.value, element.programEndDate.value)) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceFromDateAfterToDate")?.data : "Start date and time cannot be later than or equal to end date and time." });
            }
        });

        let moreDatesInvalidPerformanceDate = false;
        let moreDatesInvalidPerformanceEndDate = false;
        let moreDatesInvalidStartTime = false;
        let moreDatesInvalidEndTime = false;
        let moreDatesInvalidTimeRange = false;

        usage.moreDates?.forEach(element => {

            const usageDate = element.usageDate?.value;
            const usageEndDate = element.usageEndDate?.value;
            const programStartDate = element.programStartDate?.value;
            const programEndDate = element.programEndDate?.value;
            if (!usageDate) {
                moreDatesInvalidPerformanceDate = true;
            }
            if (!usageEndDate) {
                moreDatesInvalidPerformanceEndDate = true;
            }
            if (!programStartDate) {
                moreDatesInvalidStartTime = true;
            }
            if (!programEndDate) {
                moreDatesInvalidEndTime = true;
            }
            if (usageDate && usageEndDate && programStartDate && programEndDate) {
                const adjustedDates = adjustProgramDates(
                    programStartDate,
                    programEndDate,
                    usageDate,
                    usageEndDate
                );
                if (!adjustedDates || adjustedDates.startDate >= adjustedDates.endDate
                ) {
                    moreDatesInvalidTimeRange = true;
                }
            }
        });

        if (moreDatesInvalidPerformanceDate) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidPerformanceDate")?.data : "At least one record in More Dates has an invalid Performance Date From" });
        }
        if (moreDatesInvalidPerformanceEndDate) {
            livePerformanceIsValid.push({messageKey: fields ? fields.find(field => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidPerformanceEndDate")?.data : "At least one record in More Dates has an invalid Performance Date To"
            });
        }
        if (moreDatesInvalidStartTime) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidStartDate")?.data : "At least one record in More Dates has an invalid Start Time" });
        }
        if (moreDatesInvalidEndTime) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidEndDate")?.data : "At least one record in More Dates has an invalid End Time" });
        }
        if (moreDatesInvalidTimeRange) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesFromDateAfterToDate")?.data : "At least one record in More Dates has a start time later than or equal to the end time" });
        }

        return livePerformanceIsValid;
    }
}
